/**
 * v2 route paths. Owned by v2 — do not import from legacy.
 *
 * Paths intentionally match the legacy URLs for the same concepts so the
 * device-detection switch in src/index.tsx serves the right experience for
 * a given URL without redirects. New v2-only routes go here as features land.
 */
export const ROUTE_AUDITS = '/audits';
export const ROUTE_AUDIT_DETAIL = '/audits/details';
export const ROUTE_PERFORM_AUDIT = '/audits/perform';
export const ROUTE_TASKS = '/tasks';
export const ROUTE_TASK_DETAIL = '/tasks/details';
/**
 * The task page the legacy desktop router serves.
 *
 * The one concept whose legacy and v2 paths do NOT match: desktop registers
 * `/tasks/task-details`, v2 registers `/tasks/details`, and neither router knows the
 * other's path. A v2 component rendered inside a legacy desktop page — an audit-summary
 * tab, say — has to link here or the link 404s.
 *
 * Declared rather than imported so v2 still owns its own paths.
 */
export const ROUTE_TASK_DETAIL_DESKTOP = '/tasks/task-details';
export const ROUTE_PROFILE_PREFERENCES = '/preferences';
export const ROUTE_GENERATE_QUESTIONS = '/question/generate';
export const ROUTE_REVIEW_QUESTIONS = '/question/generate/review';
/** Fullscreen "Chat with Astra" surface. Mobile-only; gated by `enableMobileAstra`. */
export const ROUTE_CHAT = '/chat';
/** Location-level metric risk list; gated by `enableRiskEngine`. */
export const ROUTE_RISK_ENGINE = '/risk-engine';
/** Per-station metric-group impact breakdown (drill-down); gated by `enableRiskEngine`. */
export const ROUTE_RISK_ENGINE_DETAIL = '/risk-engine/details';

export type V2RoutePath =
  | typeof ROUTE_AUDITS
  | typeof ROUTE_AUDIT_DETAIL
  | typeof ROUTE_PERFORM_AUDIT
  | typeof ROUTE_TASKS
  | typeof ROUTE_TASK_DETAIL
  | typeof ROUTE_PROFILE_PREFERENCES
  | typeof ROUTE_GENERATE_QUESTIONS
  | typeof ROUTE_REVIEW_QUESTIONS
  | typeof ROUTE_CHAT
  | typeof ROUTE_RISK_ENGINE
  | typeof ROUTE_RISK_ENGINE_DETAIL;
